
import {
  CategoryMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
import Breadcrumbs from "~/components/UI/Breadcrumbs.vue";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";
import {pickSeoTitle} from "~/helpers/seo-title";

export default {
  name: "Category",

  head: function () {
    const description = this.category?.seo?.description || this.category?.metaDescription || "";
    const title = (this.category?.seo?.title || this.category?.name || this.category?.dynamicFields?.catalog_banner_title || "").replace("<br/>", " ");
    const city = this.$store.state?.appState?.config?.city?.data?.prepositional;
    // const fullTitle = [title, 'в', city].filter((t) => !!t).join(" ")
    const fullTitle = title;

    return {
      title: pickSeoTitle([fullTitle], 70),
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(fullTitle, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  fetch: async function () {
    this.$store.commit('appState/setLoading', { category: true });
    this.$store.commit('catalog/setCategory', null);
    this.$store.commit('categoryFilters/setLoading', { key: 'get', value: true });
    this.$store.commit('categoryFilters/setFilters', []);
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    this.$store.commit('appState/setLoading', { category: false });
  },

  components: {
    Breadcrumbs
  },

  mixins: [
    CategoryMixin
  ],

  computed: {
    breadcrumbs: function () {
      const categoryParent = this.category?.dynamicFields?.parent || {};
      const categoryName = (this.calculatorBlockValue?.title || this.category?.name || "").replace("<br/>", " ");

      let items = [
        { title: "Главная", path: "/" },
        { title: categoryParent?.name, path: `/${categoryParent.slug}` },
        { title: categoryName, path: this.$route.path },
      ];

      return items
    },
    categoryNameGenitiveCase: function () {
      return this.category?.dynamicFields?.category_name_genitive_case || this.category?.name || ""
    },

    // Контент для CMS блоков
    faqBlockValue: function () {
      return {
        categoryId: this.category?.id,

        useApi: true
      }
    },
    categoryTemplateDescription: function () {
      return this.category?.description || ''
    },
    categoryTemplateShortDescription: function () {
      return this.category?.shortDescription || ''
    },
    articlesBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },
    calculatorBlockValue: function () {
      return {
        title: this.category?.dynamicFields?.catalog_banner_title || this.category?.name,
        subtitle: [
          this.category?.dynamicFields?.catalog_banner_subtitle,
          this.category?.dynamicFields?.catalog_banner_caption_2,
          this.category?.dynamicFields?.catalog_banner_caption_3,
        ].filter((t) => !!t).join('<br/>'),
        caption: this.category?.dynamicFields?.catalog_banner_caption || "",
        image: this.category?.dynamicFields?.catalog_banner_image || this.category?.imageId,
        categoryId: this.category.id,

        dark: true,
        useH1: true
      }
    },
    seoTagsImageBlockValue: function () {
      const categoryName = (this.category?.name || "").toLowerCase();

      return {
        title: `Безопасно доставим ${categoryName} груз по России`,
        image: this.category?.dynamicFields?.seo_tags_image_block_image
      }
    },
    shippingCostBlockValue: function () {
      const categoryName = (this.category?.name || "");

      return {
        types: [
          {
            title: `${categoryName} груз`,
            column_one_name: "Габариты груза:",
            parameters: [
              {title: "Д × Ш × В:", params: "до 12,00 × 3,50 × 3,50 м", price: "от 150 руб./км"},
              {title: "Д × Ш × В:", params: "до 12,00 × 3,50 × 3,50 м", price: "от 200 руб./км"},
            ]
          },
          {
            title: "Тяжеловесный груз",
            column_one_name: "Масса груза:",
            parameters: [
              {title: "", params: "от 25 до 40 т", price: "от 100 руб./км"},
              {title: "", params: "от 25 до 80 т", price: "от 200 руб./км"},
            ]
          },
        ]
      }
    },
    ourFleetVehiclesTemplateBlockValue: function () {
      const categoryNameGenitiveCase = (this.category?.dynamicFields?.category_name_predlozhnom_padezhe ||
          this.category?.name ||
          "").toLowerCase();

      const filters = [...this.filters].filter((t) => t.slug !== 'tip-gruza');

      return {
        category: this.category,
        products: this.products,
        pagination: {
          ...this.pagination,
          pageCount: this.pageCount
        },

        categoryTitle: `Список ${categoryNameGenitiveCase} грузов`,

        filters: filters,
        selectedFilters: this.selectedFilters,

        onChangePage: this.onChangePage.bind(this),
        onResetFilter: this.clearFilters.bind(this),
        searchProducts: this.searchProducts.bind(this),
        getUpdateFilters: this.getUpdateFilters.bind(this),
        onChangeFilterVariant: this.onChangeFilterVariant.bind(this),
      }
    },
    freightCalculatorBlockValue: function () {
      const categoryName = (this.category?.dynamicFields?.category_name_predlozhnom_padezhe || this.category?.dynamicFields?.category_name_genitive_case || this.category?.name || "").toLowerCase().replace("<br/>", " ");

      return {
        title: `Узнать стоимость ${categoryName} перевозок`,
        cargoName: this.category?.dynamicFields?.freight_calculator_cargo_name || ""
      }
    },
    typesImageFeaturesBlockValue: function () {
      return {
        products: this.products
      }
    },
    permitsTransportationOversizedCargoBlockValue: function () {
      return {
        text: `Оформление разрешения на перевозку ${this.categoryNameGenitiveCase.toLowerCase()} груза`,
        main_items: [
          {badge: "30 м", message: "по длине вместе с тягачем"},
          {badge: "5 м", message: "по ширине"},
          {badge: "5 м", message: "по высоте вместе с прицепом"},
        ]
      }
    },
    transportListTemplatesBlockValue: function () {
      const slugs = ["tip-gruza", "otrasli"];
      let filters = [];
      [...(this.filters || [])]
        .filter((t) => Boolean(slugs.includes(t.slug)))
        .map((filter) => {
          (filter?.variants || []).map((variant) => {
            filters.push(`filter[${filter.slug}][]=${variant.slug}`)
          });
        });

      if (filters.length > 0) {
        [
          this.category?.dynamicFields?.suitable_transport_1,
          this.category?.dynamicFields?.suitable_transport_2,
          this.category?.dynamicFields?.suitable_transport_3,
        ].filter((t) => !!t).map((item) => {
          filters.push(`filter[transport][]=${item}`);
        })
      }

      return {
        title: "Подберём транспорт подходящий под параметры вашего груза",
        filter: filters.join("&"),
        category: this.category,
        versionBlock: Boolean(this.category?.dynamicFields?.transport_list_templates_version) ? 2 : 1
      }
    },
    directionsCompletedProjectsBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },

    afterCmsPageId: function () {
      return this.category?.dynamicFields?.after_cms_page_id || null
    },
    extensions: function () {
      return ['seo_title']
    },
    extensionsCategory: function () {
      return ['parent']
    },
    defaultPerPage: function () {
      return 24
    }
  },

  destroyed: async function () {
    await this.$store.commit('sets/setCategoryDetailed', null);
  }
}
